import { useDecision } from '@optimizely/react-sdk'
import { isNorthstarBrand } from '@pb/utils'

const useOptimizelyDecision = (key, autoUpdate = true): boolean => {
  const [{ enabled: isAbTestEnabled, variationKey: variation }] = useDecision(key, { autoUpdate })
  const shouldShowNorthstar =
    (isNorthstarBrand && !isAbTestEnabled) ||
    (isNorthstarBrand && isAbTestEnabled && variation === 'northstar')
  return shouldShowNorthstar
}

export const useNorthstarABTestEnabled = (key, autoUpdate = true): boolean => {
  const [{ enabled: isAbTestEnabled }] = useDecision(key, { autoUpdate })
  return isNorthstarBrand && isAbTestEnabled
}

export default useOptimizelyDecision
